import React, { createContext } from 'react';
import './snackbar-handling-lib.module.scss';

/* eslint-disable-next-line */
export interface SnackBarHandlingLibProps { }

export enum AlertType {
  error = 'error',
  success = 'sucess',
  info = 'info'
}

export interface SnackBarMessage {
  content: any,
  type: string,
  duration?: number,
  userId?: string
}

export interface iSnackBarContext {
  snackbarMessage: SnackBarMessage | undefined,
  setSnackbarMessage: React.Dispatch<React.SetStateAction<SnackBarMessage | undefined>>;
}

export const SnackBarContext = createContext<iSnackBarContext>({
  snackbarMessage: undefined,
  setSnackbarMessage: (message) => {
    console.log("Setting snackbar message:", message);
  }
});

export enum ErrorTypesEnum {
  Base = "En feil har oppstått ved ",
  //Lage kontrakt
  NewContractOrder = "opprettelse av ny kontrakt",//ikke i bruk på min side
  //Lage support kontrakt
  NewSupportContractOrder = "opprettelse av brukerstøttekontrakt",//ikke i bruk på min side
  //Inneholder
  //1. nye seter ordre
  //2. Nye lisenser/items ordre
  //3. avslutte lisens
  //4. avslutte lisens, beholde vedlikehold 
  CompositeSaleOrder = "kjøp eller kansellering av lisenser/seter",//ikke i bruk på min side
  //Inneholder
  //1. nye seter ordre
  //2. Nye lisenser/items ordre
  //3. avslutte lisens
  //4. avslutte lisens, beholde vedlikehold 
  SupportCompositeSaleOrder = "kjøp eller kansellering av lisenser/seter",//ikke i bruk på min side
  // Flytte en kontrakt fra ett firma til ett annet. Trenger IKKE være samme gruppe
  MoveContractOrder = "flytting av kontrakt mellom firmaer", //ikke i bruk på min side
  //Endre info på kontakt (kontraktansvarlig, fakturaansvarlig osv)
  ChangeContractInfoOrder = "endring av info på kontrakt",//ikke i bruk på min side
  //Slå sammen to eller flere kontrakter (flytte lisenser fra en kontrakt til en annen og fakturere mellomlegget) 
  CombineContractOrder = "sammenslåing av kontrakter",//ikke i bruk på min side
  //Endre brukertilgang og/eller koordinatorer på lisens 
  LicenseAccessOrder = "endringer av brukertilgang eller koordinator på lisens",
  //Slette en konto
  DeleteUserOrder = "sletting av brukerkonto",
  //Sletting av brukerens konto
  IsDeleted = "sletting av din brukerkonto",
  //Endre brukerkonto info (tlf, interesser osv)
  ChangeAccountOrder = "endring av brukerkontoinnstillinger",
  //Endre fornyelsestidspunkt på en kontrakt. Kan bare endres frem i tid, og betale mellomlegg
  ChangeInvoiceDateOrder = "endring av fornyelsestidspunkt på kontrakt",//ikke i bruk på min side
  //Opprett ny bruker i ett eksisterende firma
  NewUserOrder = "opprettelse av ny bruker i firma",
  //Opprett nytt firma og admin i firmaet
  NewCompanyOrder = "opprettelse av nytt firma",
  //Endre domenegodkjenning på lisenser
  DomainOrder = "Endring av domenegodkjenning på lisens",
  //Endre personer på brukerstøttekontrakt
  ChangeSupportUsersOrder = "endring av personer på brukerstøttekontrakt",
  //Be om tilgang på en lisens
  RequestLicenseAccessOrder = "ny forespørsel om tilgang på lisens",
  //Avslår en lisenstilgang, ny bruker eller nytt firma
  RejectAccessOrder = "avslag på lisenstilgang",
  //brukere er blitt invitert til å bli med i firmaet
  InviteUsersToCompanyOrder = "invitasjon av brukere til firma",
  //Endre på firmainformasjon (Kun to-faktor i versjon 1)
  ChangeCompanyInfoOrder = "Endring av firmainformasjon",
  //Ny brukerstøttemelding
  NewSupportMessageOrder = "ny brukerstøttemelding",
  //Godkjenning av uregistrert brukerforespørsel
  ActivateUnregisteredUserOrder = "opprettelse av ny bruker i firma",
  //Endring av fornyelsestidspunkt for kontrakt
  InvoiceDateOrder = "Fakturadato endret",
  //Endring av brukerkontoer fra admin/Webkua
  AdminEditAccountOrder = "Brukerkonto endret",
  //Endring firmagruppe
  ChangeCompanyGroupOrder = "Firmagruppe endret",
  //Admin endring av lisens
  AdminEditLicenseOrder = "Lisens endret (admin)",
  LicenseAccessChangeOrder = "Endring av lisenstilgang",
  CompanyContactOrder = "Endret kontaktperson",
}